import type { AnalyticsData, TimeRange } from './types';
import {
  IconUsers,
  IconActivity,
  IconContact,
  IconCreditCard,
  IconXCircle,
  IconTrendingUp,
  IconCalendar,
} from 'src/icons';
import type { StatCardConfig } from './types';

export const defaultData: AnalyticsData = {
  totalUsers: 0,
  onlineUsers: 0,
  activeUsersLast30Days: 0,
  totalContacts: 0,
  subscriptionActive: 0,
  subscriptionCanceled: 0,
  newUsersThisWeek: 0,
  newUsersThisMonth: 0,
  newSignupsInRange: 0,
  revenue: 0,
  engagementRate: 0,
};

export const timeRanges: TimeRange[] = [
  { label: 'Today', value: 'today' },
  { label: 'Last 7 days', value: 'week' },
  { label: 'Last 30 days', value: 'month' },
  { label: 'Last 90 days', value: 'quarter' },
  { label: 'Custom', value: 'custom' },
];

export const cardConfigs: StatCardConfig[] = [
  { label: 'Total Users', valueKey: 'totalUsers', icon: IconUsers, color: 'from-blue-500 to-cyan-500', bgColor: 'bg-gradient-to-br from-blue-50 to-cyan-50', barColor: 'bg-blue-500', trendKey: null, description: 'Registered users' },
  { label: 'Online Now', valueKey: 'onlineUsers', icon: IconActivity, color: 'from-teal-500 to-cyan-500', bgColor: 'bg-gradient-to-br from-teal-50 to-cyan-50', barColor: 'bg-teal-500', trendKey: null, description: 'Users with active session' },
  { label: 'Active Users', valueKey: 'activeUsersLast30Days', icon: IconActivity, color: 'from-green-500 to-emerald-500', bgColor: 'bg-gradient-to-br from-green-50 to-emerald-50', barColor: 'bg-green-500', trendKey: 'activeUsersLast30Days', description: 'Active in selected range' },
  { label: 'Total Contacts', valueKey: 'totalContacts', icon: IconContact, color: 'from-purple-500 to-violet-500', bgColor: 'bg-gradient-to-br from-purple-50 to-violet-50', barColor: 'bg-purple-500', trendKey: null, description: 'Contact entries' },
  { label: 'Active Subs', valueKey: 'subscriptionActive', icon: IconCreditCard, color: 'from-emerald-500 to-teal-500', bgColor: 'bg-gradient-to-br from-emerald-50 to-teal-50', barColor: 'bg-emerald-500', trendKey: null, description: 'Current subscriptions' },
  { label: 'Canceled Subs', valueKey: 'subscriptionCanceled', icon: IconXCircle, color: 'from-rose-500 to-pink-500', bgColor: 'bg-gradient-to-br from-rose-50 to-pink-50', barColor: 'bg-rose-500', trendKey: null, description: 'Canceled this period' },
  { label: 'New Signups', valueKey: 'newSignupsInRange', icon: IconTrendingUp, color: 'from-amber-500 to-orange-500', bgColor: 'bg-gradient-to-br from-amber-50 to-orange-50', barColor: 'bg-amber-500', trendKey: 'newSignups', description: 'New users in selected range' },
  { label: 'Monthly Growth', valueKey: 'newUsersThisMonth', icon: IconCalendar, color: 'from-indigo-500 to-blue-500', bgColor: 'bg-gradient-to-br from-indigo-50 to-blue-50', barColor: 'bg-indigo-500', trendKey: null, description: 'New users last 30 days' },
];
